var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTouchInclusions = function SvgTouchInclusions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5H13v3h11zm-9 5h9v3h-9zm-3.024 5h24.048a1.69 1.69 0 0 1 1.365.695l6.45 8.868a.844.844 0 0 1-.063 1.068L24.62 46.383a.843.843 0 0 1-1.19.047q-.016-.014-16.742-18.132l-.004-.005-.03-.031-2.429-2.632a.84.84 0 0 1-.063-1.068l6.45-8.868A1.69 1.69 0 0 1 11.976 15m.86 3.374L8.112 24.87 24 42.078 39.888 24.87l-4.724-6.496zM18 20h6v3h-6zm6 4h-4v3h4z"
  })));
};
export default SvgTouchInclusions;